import React from "react"

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  size?: string | number
  color?: string
  title?: string
}

export const MdStoreMallDirectory: React.FC<IconProps> = ({
  size = "1em",
  color = "currentColor",
  title,
  ...props
}) => {
  return (
    <svg
      stroke="currentColor"
      fill="currentColor"
      strokeWidth="0"
      viewBox="0 0 24 24"
      height={size}
      width={size}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {title && <title>{title}</title>}
      <path fill="none" d="M0 0h24v24H0z" />
      <path d="M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z" />
    </svg>
  )
}

export default MdStoreMallDirectory
